import { EDocumentEsActions, EsDocumentActions } from "@edp-store/actions/ES/document-es.actions";
import { IDocumentEs, initialDocumentEsState } from "@edp-store/state/ES/document-es.state";

export function DocumentEsReducers(state = initialDocumentEsState, action: EsDocumentActions): IDocumentEs {
    switch (action.type) {
        case EDocumentEsActions.SetDocumentEs: {
            return {
                ...state,
                document: action.payload,
            };
        }
        default:
            return state;
    }
}
